/*
 * @Description: 巴西和墨西哥 外场
 * @Author: gaolei
 * @Date: 2025-10-18
 * @LastEditTime: 2025-10-18 15:21:00
 * @LastEditors: gaolei
 */

import { useAuthStore } from '@/stores/login'
import 'vant/lib/index.css'
import dsBridge from 'dsbridge'
import { loading } from '@/utils/loading'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import CryptoJS from 'crypto-js'
import router from '@/router'
import { useUsersStore } from '@/stores/users'

// 判断是否是Native App内嵌沙滩说
export const isSandsTalkBrMexApp = window.navigator.userAgent.indexOf('brOutfieldApp') > -1 || window.navigator.userAgent.indexOf('mexOutfieldApp') > -1

// 在项目中创建一个全局声明文件（如：global.d.ts）
declare global {
  interface Window {
    jtJsBridge?: {
      jtH5CallNativeApi: (request: any, callback: (responseData: any) => void) => void
    }
  }
}

const callNative = async (request: { method: string; data?: any }): Promise<any> => {
  return new Promise((resolve, reject) => {
    dsBridge.call('jtH5CallNativeApi', request, (responseData) => {
      if (responseData && typeof responseData === 'string') {
        try {
          const parsedResponse = JSON.parse(responseData)
          resolve(parsedResponse)
        } catch (error) {
          resolve(responseData)
        }
      } else {
        resolve(responseData)
      }
    })
  })
}

// 获取签名
function getSign(params: any, secret: any, timestamp: any) {
  const paramsJson = params ? JSON.stringify(params, Object.keys(params).sort()) : 'N_V'
  const stringToSign = `${paramsJson}\n${timestamp}\n${secret}`

  // 将 stringToSign 直接作为 HMAC 密钥使用，确保与 Java 逻辑一致
  const hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, CryptoJS.enc.Utf8.parse(stringToSign))
  const signData = hmac.finalize(CryptoJS.lib.WordArray.create([]))

  // 返回 Base64 编码的签名
  return CryptoJS.enc.Base64.stringify(signData)
}

export const sandsTalkBrMexOutfieldLogin = async () => {
  loading.show()
  try {
    const request = { method: 'InitForShatanChannel', data: {} }
    // 假设 callNative 返回的就是如下对象
    const res = await callNative(request)
    let getUserInfor = JSON.parse(res.data)

    let appId = ''
    let signSecret = ''
    let appUniqueId = ''
    let language = ''
    let identifierType = ''

    language = getLangKey(getUserInfor.lang) || 'en-us'
    localStorage.setItem('lang', getLangKey(getUserInfor.lang) || 'en-us')
    // 准备请求参数
    const timestamp = Date.now()
    if (getUserInfor.source === 'brOutfieldApp') {
      appId = 'br_outfield_app' // 由沙滩说提供
      signSecret = 'XTpSQnM1k70jHf7HkHf' // 由沙滩说提供
      appUniqueId = 'br_outfield_app'
      identifierType = 'account'
      // 存储原生给的用户信息数据到 localStorage
      localStorage.setItem('SandsTalkBrMexUserInfo', JSON.stringify(getUserInfor))
    } else if (getUserInfor.source === 'mexOutfieldApp') {
      appId = 'mex_outfield_app' // 由沙滩说提供
      signSecret = 'oNhJqiuCiikjBEby'
      appUniqueId = 'mex_outfield_app'
      identifierType = 'account'
      // 存储原生给的用户信息数据到 localStorage
      localStorage.setItem('SandsTalkBrMexUserInfo', JSON.stringify(getUserInfor))
    }

    const noce = uuidv4()

    const params = {
      appId,
      identifierType: identifierType || '',
      identifierValue: getUserInfor.identifierValue || '',
      noce,
      timestamp,
    }

    // 生成签名
    const sign = getSign(params, signSecret, timestamp)

    // 构造最终的请求数据
    const finalRequestData = {
      appId,
      identifierType: identifierType || '',
      identifierValue: getUserInfor.identifierValue || '',
      noce,
      sign,
      timestamp,
    }

    // 发送请求
    try {
      const { data } = await axios.post(
        `${process.env.VUE_APP_API_URL}/sands-user/api/v1/auth/authorization-token`,
        JSON.stringify(finalRequestData),
        {
          headers: {
            'Content-Type': 'application/json',
            'accept-language': language
          }
        }
      )

      if (data.code === 1) {
        loading.hide()
        const authStore = useAuthStore()
        authStore.setAccessToken(data.data.access_token)
        localStorage.setItem('sandsTalkToken', data.data.access_token)
        localStorage.setItem('sandsTalkTenantId', data.data.tenantId || '1000')
        const usersStore = useUsersStore()
        const { setCollegeId } = usersStore
        setCollegeId(data.data.collegeId)
        if (getUserInfor.sourceType === 'task') {
          router.replace('/task')
        } else {
          router.replace('/')
        }
        return data.data.access_token
      } else {
        const authStore = useAuthStore()
        authStore.setAccessToken('')
        localStorage.removeItem('sandsTalkToken')
        loading.hide()
        brMexOutFieldShowToast(data.msg)
        brMexOutFieldCloseWebview()
      }
    } catch (error) {
      const authStore = useAuthStore()
      authStore.setAccessToken('')
      localStorage.removeItem('sandsTalkToken')
      loading.hide()
      brMexOutFieldShowToast(error + '')
      brMexOutFieldCloseWebview()
    }
  } catch (error) {
    const authStore = useAuthStore()
    authStore.setAccessToken('')
    localStorage.removeItem('sandsTalkToken')
    loading.hide()
    brMexOutFieldCloseWebview()
    console.error('获取Token失败:', error)
    return {}
  }
}

// 下载H5链接  (文件下载)
export const sandsTalkBrMexLauncherUrl = (url: string, name: string) => {
  const request = { method: 'OpenFileChannel', data: { url, name } }
  callNative(request)
}

// 外场关闭webview
export const brMexOutFieldCloseWebview = async () => {
  const request = { method: 'FinishPageChannel' }
  await callNative(request)
}

// 显示toast提示
export const brMexOutFieldShowToast = (message: string) => {
  const request = { method: 'ToastChannel', data: { message } }
  callNative(request)
}

// 外场打开新页面
export const brMexOutFieldNativeUrl = async (url: string) => {
  dsBridge.call('goToNativeLoadUrl', url)
}

export const brMexOutFieldSetHoriVerti = (isFull: boolean) => {
  const request = { method: 'nativeSetHoriVerti', data: { isFull } }
  callNative(request)
}

// 外场销毁页面，返回上一页
export const registerPreviousH5 = async () => {
  dsBridge.register('previous', function (result: any) {
    const isApp = router.currentRoute.value.meta?.isBrMexOutFieldApp
    if (isApp) {
      brMexOutFieldCloseWebview()
    } else {
      router.go(-1)
    }
  })
}

export const getLangKey = (lang: string) => {
  switch (lang) {
    case 'CN':
      return 'zh-cn'
    case 'EN':
      return 'en-us'
    default:
      return 'en-us'
  }
}
